import { Button } from '@any-ui-react/core';

import { PlusIcon } from '@anyx/shared-icons';

import { NumOfBlocks } from '../sortable-blocks';

export interface AddMessageElementProps {
  currentLength: number;
  maxLength: number;
  onAppend: () => void;
  label: string;
}

export const AddMessageElement = ({
  currentLength,
  maxLength,
  onAppend,
  label,
}: AddMessageElementProps) => {
  return (
    <div className="flex w-max flex-col gap-y-1">
      {currentLength < maxLength && (
        <Button
          size="md"
          variant="default"
          leftSection={<PlusIcon className="h-4 w-4" />}
          onClick={onAppend}
        >
          {label}
        </Button>
      )}
      <NumOfBlocks current={currentLength} max={maxLength} />
    </div>
  );
};
